import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Status from './components/status/index';
import Badges from './components/badges/index';
import ProfileImage from './components/profile_image/index';
import ProfileLink from './components/profile_link/index';
import Oneliner from './components/oneliner/index';
import Buttons from './components/buttons/index';
import Pro from './components/pro/index';
import Stats from './components/stats/index';
import Description from './components/description/index';
import translations from './translations.en.json';
import '@fiverr/globals';
import './index.scss';

class SellerCard extends PureComponent {

    constructor(props) {
        super(props);
        i18n.add(translations);

        this.state = {
            isOnline: false,
            isOnVacation: props.user.is_on_vacation
        };

        this.toggleVacation = this.toggleVacation.bind(this);
    }

    componentDidMount() {
        if (document) {
            document.addEventListener('popup_close', () => {
                this.setState({
                    isOnVacation: false
                });
            });

            document.addEventListener('out_of_office_on', () => {
                this.setState({
                    isOnVacation: true
                });
            });
        }

        const {
            user
        } = this.props;

        // this has a lot of checking to ensure this fails silently
        // when running in static or dev mode
        gofor(`/users/${user.username}/is_online`, {
            method: 'GET'
        }).then((response) => response.json())
            .then((response) => {
                if (response) {
                    this.setState({
                        isOnline: response.is_online === true
                    });
                }
            })
            .catch((err) => { throw err; });

    }

    toggleVacation(e) {

        e.preventDefault();
        e.stopPropagation();

        const {
            user
        } = this.props;

        if (this.state.isOnVacation) {
            gofor(`/users/${user.username}/vacations`, {
                method: 'delete'
            }).then((response) => {
                if (response) {
                    const event = new CustomEvent('open_popup', {detail: false});
                    document.dispatchEvent(event);
                    this.setState({
                        isOnVacation: false
                    });
                }
            }).catch((err) => { throw err; });
        } else {
            const event = new CustomEvent('open_popup', {detail: true});
            document.dispatchEvent(event);
            this.setState({
                isOnVacation: true
            });
        }
    }

    render() {

        const {
            isOnline,
            isOnVacation
        } = this.state;

        const {
            user,
            allowEditing,
            viewingAsBuyer,
            isMobileResponsive,
            currentUser,
            showDescription,
            showCustomOrder,
            authToken,
            inWhitingContactButton
        } = this.props;

        const isCurrentUser      = currentUser ? true : false, // eslint-disable-line
            neverLinkName        = !showDescription, // when we're showing the description, we want to link the username as well
            allowEditingReal     = allowEditing && !viewingAsBuyer, // if the user is in "buyer preview"-mode, editing is disabled
            showAmbassador       = user.is_ambassador,
            showNow              = user.is_now_seller,
            showDescriptionReal  = showDescription && user.description && user.description.length > 0,
            showPro              = user.is_pro && user.pro_sub_categories && !!user.pro_sub_categories.length;

        return (

            <div className="user-main-info">
                <Status isOnline={isOnline} userId={user.id} isOnVacation={isOnVacation}/>

                {(showAmbassador || showNow) &&
                    <Badges userName={user.username} showAmbassador={showAmbassador} showNow={showNow}/>
                }

                <ProfileImage user={user} allowEditing={allowEditingReal} authToken={authToken}/>
                <ProfileLink userName={user.username} noLink={neverLinkName}/>
                <Oneliner user={user} allowEditing={allowEditingReal} authToken={authToken}/>
                <Buttons user={user} isMobileResponsive={isMobileResponsive} allowEditing={allowEditingReal} viewingAsBuyer={viewingAsBuyer} isCurrentUser={isCurrentUser} showCustomOrder={showCustomOrder} inWhitingContactButton={inWhitingContactButton}/>

                {showPro &&
                    <Pro proCategories={user.pro_sub_categories}/>
                }

                <Stats user={user} allowEditing={allowEditingReal} isOnVacation={isOnVacation} toggleVacation={this.toggleVacation}/>

                {showDescriptionReal &&
                    <Description userDescription={user.description}/>
                }
            </div>
        );
    }
}

SellerCard.propTypes = {
    user: PropTypes.object.isRequired,
    allowEditing: PropTypes.bool.isRequired,
    viewingAsBuyer: PropTypes.bool.isRequired,
    isMobileResponsive: PropTypes.bool.isRequired,
    currentUser: PropTypes.object.isRequired,
    showDescription: PropTypes.bool.isRequired,
    showCustomOrder: PropTypes.bool.isRequired,
    authToken: PropTypes.string
};

SellerCard.defaultProps = {
    user: {},
    allowEditing: false,
    viewingAsBuyer: false,
    isMobileResponsive: false,
    currentUser: {},
    showDescription: true,
    showCustomOrder: true,
    authToken: ''
};

export default SellerCard;


// WEBPACK FOOTER //
// ./src/SellerCard.js